import { request } from "../../base";
import type { PipelineStage, LeadSource } from "./types";

export const crmPipelineApi = {
	// Pipeline Stages
	async getStages(proId: string) {
		return request<PipelineStage[]>(
			`/api/pro/${proId}/crm/pipeline-stages`,
		);
	},

	async createStage(proId: string, data: { name: string }) {
		return request<PipelineStage>(
			`/api/pro/${proId}/crm/pipeline-stages`,
			{ method: "POST", body: data },
		);
	},

	async updateStage(
		proId: string,
		stageId: number,
		data: { name: string },
	) {
		return request<PipelineStage>(
			`/api/pro/${proId}/crm/pipeline-stages/${stageId}`,
			{ method: "PATCH", body: data },
		);
	},

	async deleteStage(
		proId: string,
		stageId: number,
		reassignToStageId?: number,
	) {
		return request<{ deleted: true }>(
			`/api/pro/${proId}/crm/pipeline-stages/${stageId}`,
			{
				method: "DELETE",
				body: reassignToStageId ? { reassignToStageId } : undefined,
			},
		);
	},

	async reorderStages(proId: string, stageIds: number[]) {
		return request<PipelineStage[]>(
			`/api/pro/${proId}/crm/pipeline-stages/reorder`,
			{ method: "PUT", body: { stageIds } },
		);
	},

	// Lead Sources
	async getSources(proId: string, includeInactive = false) {
		const url = includeInactive
			? `/api/pro/${proId}/crm/lead-sources?includeInactive=true`
			: `/api/pro/${proId}/crm/lead-sources`;
		return request<LeadSource[]>(url);
	},

	async createSource(proId: string, data: { name: string }) {
		return request<LeadSource>(
			`/api/pro/${proId}/crm/lead-sources`,
			{ method: "POST", body: data },
		);
	},

	async deactivateSource(proId: string, sourceId: number) {
		return request<LeadSource>(
			`/api/pro/${proId}/crm/lead-sources/${sourceId}/deactivate`,
			{ method: "PATCH" },
		);
	},

	async reactivateSource(proId: string, sourceId: number) {
		return request<LeadSource>(
			`/api/pro/${proId}/crm/lead-sources/${sourceId}/reactivate`,
			{ method: "PATCH" },
		);
	},
};
